import type { FieldGridItem } from "@/components/layout-2/ds";
import type { FieldDataType } from "@/types/dynamic-detail";
import { formatNumber } from "@/utils/format-fr";
import type { SettingsUsed } from "./types";

/** Label of an option of the served form (`Every 15 minutes`), as the form itself shows it. */
const optionLabel = (fields: FieldDataType[], name: string, value: unknown) =>
    fields.find(field => field.field_name === name)?.options?.find(option => String(option.value) === String(value))?.label ?? String(value);

/** Settings of a pass or of the preview, as label / value rows. The ListView and its filters are shown by the caller. */
export function settingsItems(settings: SettingsUsed, fields: FieldDataType[]): FieldGridItem[] {
    return [
        { label: "Run", value: `${optionLabel(fields, "period_minutes", settings.period_minutes)} · cap ${formatNumber(settings.cap_per_pass)}` },
        { label: "Order", value: optionLabel(fields, "order", settings.order) },
        {
            label: "Rules",
            value: `${settings.allow_same_contact_multiple ? "Same contact several times" : settings.once_per_contact ? "Same contact once, ever" : "Same contact once at a time"} · ${settings.reinject_finished ? `re-injection after ${settings.reinject_min_delay_days} days` : "no re-injection"}`
        },
        { label: "Exclusions", value: settings.exclusions.join(", ") }
    ];
}
